'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFound() {
	const router = useRouter();
	const pathname = usePathname();

	useEffect(() => {
		if (pathname) {
			router.replace('https://supra.com/not-found/');
		}
	}, [pathname, router]);

	return null;
}
